import {
  Box, Container,
  Typography
} from "@mui/material";
import { useEffect, useMemo } from "react";
import { RouteComponentProps, useLocation, withRouter } from "react-router-dom";
import { useBreadcrumbState } from "../../../store/breadcrumbState";
import SplitButton from "../../common/tree/button";
import ProjectTable from "./ProjectsTable";
import useFetch from "../../../hooks/http/useFetch";
import { isEmpty } from "lodash";

const ProjectView: React.FC<RouteComponentProps> = ({ history }) => {

  const search = useLocation().search;
  const groupId = useMemo(() => new URLSearchParams(search).get('groupId'), [search])
  const {data: groupData } = useFetch(groupId? `/group/${groupId}`: undefined)
  const setOverrideBreadcrumb = useBreadcrumbState((state) =>
    //@ts-ignore
    state.setOverrideBreadcrumb)
  const selectedGroup = useBreadcrumbState((state) =>
    //@ts-ignore
    state.selectedGroup)
  const selectedProject = useBreadcrumbState((state) =>
    //@ts-ignore
    state.selectedProject)

  useEffect(() => {
    
    if (!isEmpty(groupData)) setOverrideBreadcrumb({
      group: { id: groupData?.id, name:groupData?.name }
    })
  },
    [groupData, setOverrideBreadcrumb])

  return (
    <>
      <Box
        sx={{
          backgroundColor: "background.paper",
          display: "flex",
          // flexDirection: "column",
          minHeight: '100%',
        }}
      >
        <Container maxWidth={false} sx={{ p: 3, pt: 1.5 }}>

          <Box
            sx={{
              alignItems: "left",
              display: "flex",
              justifyContent: "start",
              mb: 3,
            }}
          >
            {/**Group name */}


            <Box sx={{ display: "flex", justifyContent: "start", alignItems: "left", }}>


              <Typography
                color="textPrimary"
                gutterBottom
                variant="h4"
                sx={{ textAlign: "left", mr: 2 }}
              >
                Projects
              </Typography>
              <SplitButton groupId={selectedGroup?.id} />
            </Box>


          </Box>

          <Box
            sx={{
              flexGrow: 1,
            }}
          >
            <ProjectTable groupId={selectedGroup?.id} projectId={selectedProject?.id} />
            {/* <ResultsTable groupId={groupId} /> */}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default withRouter(ProjectView);
